import { useLocation } from 'react-router-dom'; // if you use react-router
import { Logger } from '../../config/logging/logger';

const scrollPositions: Record<string, number> = {};

export function useScrollRestoration() {
  const location = useLocation();
  const path = location.pathname;
  const logger = Logger.create('useScrollRestoration');

  return {
    saveScroll() {
      logger.debug(Logger.format('scroll:save', path, window.scrollY, scrollPositions));
      scrollPositions[path] = window.scrollY;
    },
    restoreScroll() {
      const y = scrollPositions[path];
      if (y) {
        delete scrollPositions[path];
        logger.debug(Logger.format('scroll:restore', path, y, scrollPositions, scrollPositions[path]));
        window.scrollTo({ top: y, behavior: 'auto' });
        return true;
      }
      return false;
    },
  };
}
